/**
 * @generated SignedSource<<22470bd65ce634e2e1770063659a8cfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyItNowButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_user">;
  readonly " $fragmentType": "PdpSharedBuyItNowButton_user";
};
export type PdpSharedBuyItNowButton_user$key = {
  readonly " $data"?: PdpSharedBuyItNowButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyItNowButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dc802d1d4cf2d20784ddab62d1d8abf2";

export default node;
